module.exports = __webpack_public_path__ + "img/404.ea292eb4.png";